import {Component, OnInit} from '@angular/core';
import {Pages} from "../../dto/Pages";
import {Table, TableModule} from "primeng/table";
import {AdminTemplateComponent} from "../admin-template/admin-template.component";
import {AdminEditPageComponent} from "../admin-edit-page/admin-edit-page.component";
import {NgIf} from "@angular/common";
import {DateTextPipe} from "../../pips/date-text.pipe";
import {NumberTextPipe} from "../../pips/number-text.pipe";
import {CheckboxModule} from "primeng/checkbox";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-admin-blogs',
  standalone: true,
  imports: [
    AdminEditPageComponent,
    NgIf,
    TableModule,
    DateTextPipe,
    NumberTextPipe,
    CheckboxModule,
    FormsModule,
  ],
  templateUrl: './admin-blogs.component.html',
  styleUrl: './admin-blogs.component.css'
})
export class AdminBlogsComponent extends AdminTemplateComponent implements OnInit  {
  displayMode: string = "Tbl";
  page: Pages = new Pages();
  listPages: Array<Pages> = new Array<Pages>();
  totalPage: number = 0;

  ngOnInit() {
    this.checkLogin();
  }

  loadListPages(table: Table) {
    let params = {};
    let body = this.page;
    this.global.progressBar = true;
    var observable = this.restBack.doGet("lnd/page/get_pages?" +
        "page=" + (table != null ? table.first / 10 : 0) +
        "&nrpp=" + (table != null && table.rows ? table.rows : 10)+
        "&type=BLOG" );
    observable.subscribe({
      next: (res: string) => {
        if (res["status"] == 200) {
          this.listPages = res["entity"];
          this.totalPage = res["total"];

        }
        if (res["status"] == 401) {
          this.gotoLogin();
        }
        return res;
      },
      error: (e) => {
        this.messageService.clear();
        this.messageService.add({
              severity: 'error',
              summary: $localize`:@@Error:Error`,
              detail: $localize`:@@Server Timout Det:Server Timout Det`
            }
        );
      },
      complete:()=>{
        this.global.progressBar = false;
      }
    });
  }

  newPage() {
    this.page = new Pages();
    this.page.type = "BLOG";
    this.displayMode = "Edit";
  }

  savePageEvent() {
    this.displayMode = "Tbl";
  }

  cancelSaveEvent() {
    this.displayMode = "Tbl";
  }

  editPage(page: Pages) {
    this.page = page;
    this.displayMode = "Edit";

  }

  deletePage(page: Pages,table: Table) {
    this.confirmationService.confirm({
      message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
      header: $localize`:@@Delete:Delete`,
      acceptLabel: $localize`:@@Yes:Yes`,
      rejectLabel: $localize`:@@No:No`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/page/delete_page?" +
            "uid=" + page.uid);
        observable.subscribe({
          next: (res: string) => {
            if (res["status"] == 200) {
              this.messageService.clear();
              this.messageService.add({
                    severity: 'info',
                    summary: $localize`:@@Delete:Delete`,
                    detail: $localize`:@@Delete Success:Delete Success`
                  }
              );
              this.loadListPages(table);
            }
            if (res["status"] == 401) {
              this.gotoLogin();
            }
            return res;
          },
          error: (e) => {
            this.messageService.clear();
            this.messageService.add({
                  severity: 'error',
                  summary: $localize`:@@Error:Error`,
                  detail: $localize`:@@Server Timout Det:Server Timout Det`
                }
            );
          },
          complete: () => {
            this.global.progressBar = false;
          }
        });
      }
    });
  }

    protected readonly window = window;
}
